// ── services/api/pincode.api.ts ───────────────────────────────────────────────
// Village lookup for the Samaj node form. Backed by an interim data source —
// see backend/src/services/pincodeLookup.service.ts for the caveat and the
// India Post official-directory follow-up tracked in
// Fronend docs/samaj_layout_engine_design.md §10.

import { api } from './client';

export interface VillageCandidate {
  village:  string;
  district: string;
  state:    string;
}

export const pincodeApi = {
  /** Candidate villages for a 6-digit Indian PIN code — never a single auto-filled value. */
  lookup: (pincode: string) =>
    api.get<{ data: VillageCandidate[] }>(`/pincode/${pincode}`),
};
